import React from 'react';

const SubmitMessage = () => {
  return (
    <div>
      <p>
        <strong>
          Name, phone number and address:
          {' '}
        </strong>
        we need these details to process a Gift Aid claim on your donation.
      </p>
    </div>
  );
};

export default SubmitMessage;
